import React from 'react'
import { LinkButton } from '@enamelai/design-system'
import { Icon as AddIcon } from '@enamelai/design-system/icons/Add'
import './TxPlanPhaseAddProcedureRow.css'

interface TxPlanPhaseAddProcedureRowProps {
  onAddProcedure: () => void
}

const TxPlanPhaseAddProcedureRow = ({
  onAddProcedure,
}: TxPlanPhaseAddProcedureRowProps): React.ReactElement => {
  return (
    <div className="tx-plan-phase-add-procedure-row">
      <LinkButton
        type="button"
        size="sm"
        underline={false}
        aria-label="Add procedures to this phase"
        leftIcon={<AddIcon width={16} height={16} aria-hidden />}
        onClick={onAddProcedure}
      >
        Add procedures
      </LinkButton>
    </div>
  )
}

export default TxPlanPhaseAddProcedureRow
